<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderSettlement.search.userId')" prop="userId">
                <a-input
                  v-model="queryParam.userId"
                  :placeholder="$t('views.orderSettlement.search.userIdPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col> -->

            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderSettlement.search.email')" prop="email">
                <a-input
                  v-model="queryParam.email"
                  :placeholder="$t('views.orderSettlement.search.emailPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderSettlement.search.nickname')" prop="nickname">
                <a-input
                  v-model="queryParam.nickname"
                  :placeholder="$t('views.orderSettlement.search.nicknamePlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderSettlement.search.orderNo')" prop="orderNo">
                <a-input
                  v-model="queryParam.orderNo"
                  :placeholder="$t('views.orderSettlement.search.orderNoPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderSettlement.search.orderStatus')" prop="orderStatus">
                <a-select
                  v-model="queryParam.orderStatus"
                  :placeholder="$t('views.orderSettlement.search.orderStatusPlaceholder')"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in orderStatusOptions"
                    :key="'os-' + item.value"
                    :value="item.value"
                  >{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('views.orderSettlement.action.query') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('views.orderSettlement.action.reset') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:orderSettlement:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:orderSettlement:edit']">
          <a-icon type="edit" />修改
        </a-button> -->
        <a-button type="primary" style="margin-right: 8px" :loading="generateLoading" @click="handleGenerate" v-hasPermi="['user:orderSettlement:generate']">
          <a-icon type="sync" />{{ $t('views.orderSettlement.action.generate') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:orderSettlement:remove']">
          <a-icon type="delete" />{{ $t('views.orderSettlement.action.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="orderStatus" slot-scope="text, record">
          {{ formatOrderSettlementOrderStatus(record.orderStatus) }}
        </span>
        <!-- 排序、状态列已按需求注释
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        -->
        <span slot="money" slot-scope="text, record">
          {{ formatMoney(record.money) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
             <a-divider type="vertical" v-hasPermi="['user:settlementPayment:list']" />
          <a @click="openPaymentDrawer(record)" v-hasPermi="['user:settlementPayment:list']">
            <a-icon type="pay-circle" />{{ $t('views.orderSettlement.action.paymentRecords') }}
          </a>
          <!-- <a-divider type="vertical" v-hasPermi="['user:orderSettlement:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:orderSettlement:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['user:orderSettlement:remove']" /> -->
             <a-divider type="vertical" v-hasPermi="['user:orderSettlement:remove']" />
          <a style="margin-left: 8px" @click="handleDelete(record)" v-hasPermi="['user:orderSettlement:remove']">
            <a-icon type="delete" />{{ $t('views.orderSettlement.action.delete') }}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :show-total="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <a-drawer
      :title="paymentDrawerTitle"
      placement="right"
      :width="paymentDrawerWidth"
      :visible="paymentDrawerVisible"
      :destroy-on-close="true"
      wrap-class-name="order-settlement-payment-drawer"
      @close="closePaymentDrawer"
    >
      <settlement-payment
        v-if="paymentDrawerVisible && paymentDrawerSettlementId != null"
        :embedded="true"
        :settlement-id="paymentDrawerSettlementId"
      />
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import { pageOrderSettlement, delOrderSettlement, generateOrderSettlement } from '@/api/user/orderSettlement'
import CreateForm from './modules/CreateForm'
import SettlementPayment from '@/views/user/settlementPayment/index.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderSettlement',
  components: {
    CreateForm,
    SettlementPayment
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      generateLoading: false,
      total: 0,
      paymentDrawerVisible: false,
      paymentDrawerSettlementId: null,
      queryParam: {
        userId: null,
        orderNo: null,
        email: null,
        nickname: null,
        orderStatus: null,
        startDate: null,
        endDate: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  computed: {
    paymentDrawerWidth () {
      const w = typeof window !== 'undefined' ? window.innerWidth : 1200
      return Math.min(960, Math.max(480, w - 80))
    },
    paymentDrawerTitle () {
      return this.$t('views.orderSettlement.drawer.paymentTitle')
    },
    orderStatusOptions () {
      return [
        { value: 0, label: this.$t('views.orderSettlement.orderStatus.awaitPay') },
        { value: 1, label: this.$t('views.orderSettlement.orderStatus.awaitAudit') },
        { value: 2, label: this.$t('views.orderSettlement.orderStatus.auditRejected') },
        { value: 3, label: this.$t('views.orderSettlement.orderStatus.completed') }
      ]
    }
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.orderSettlement.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        // { title: t('views.orderSettlement.column.userId'), dataIndex: 'userId', ellipsis: true, align: 'center' },
        { title: t('views.orderSettlement.column.email'), dataIndex: 'email', ellipsis: true, align: 'center' },
        { title: t('views.orderSettlement.column.nickname'), dataIndex: 'nickname', ellipsis: true, align: 'center' },
        { title: t('views.orderSettlement.column.orderNo'), dataIndex: 'orderNo', ellipsis: true, align: 'center' },
        {
          title: t('views.orderSettlement.column.orderStatus'),
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.orderSettlement.column.money'),
          dataIndex: 'money',
          scopedSlots: { customRender: 'money' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.orderSettlement.column.startDate'), dataIndex: 'startDate', ellipsis: true, align: 'center' },
        { title: t('views.orderSettlement.column.endDate'), dataIndex: 'endDate', ellipsis: true, align: 'center' },
        {
          title: t('views.orderSettlement.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.orderSettlement.column.operation'),
          dataIndex: 'operation',
          width: 240,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.orderSettlement.pagination.total', { total })
    },
    formatOrderSettlementOrderStatus (value) {
      if (value === null || value === undefined || value === '') {
        return this.$t('views.orderSettlement.cell.dash')
      }
      const n = Number(value)
      const hit = (this.orderStatusOptions || []).find(o => Number(o.value) === n)
      return hit ? hit.label : String(value)
    },
    formatMoney (v) {
      if (v === null || v === undefined || v === '') {
        return this.$t('views.orderSettlement.cell.dash')
      }
      const n = Number(v)
      if (Number.isNaN(n)) {
        return String(v)
      }
      return n.toFixed(2)
    },
    getList () {
      this.loading = true
      pageOrderSettlement(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    openPaymentDrawer (record) {
      if (!record || record.id == null) {
        return
      }
      this.paymentDrawerSettlementId = record.id
      this.paymentDrawerOrderNo = record.orderNo || null
      this.paymentDrawerVisible = true
    },
    closePaymentDrawer () {
      this.paymentDrawerVisible = false
      this.paymentDrawerSettlementId = null
    },
    handleGenerate () {
      const that = this
      this.$confirm({
        title: this.$t('views.orderSettlement.confirm.generateTitle'),
        content: this.$t('views.orderSettlement.confirm.generateContent'),
        onOk () {
          that.generateLoading = true
          return generateOrderSettlement()
            .then(() => {
              that.getList()
              that.$message.success(that.$t('views.orderSettlement.msg.generateOk'), 3)
            })
            .finally(() => {
              that.generateLoading = false
            })
        }
      })
    },
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        orderNo: undefined,
        email: undefined,
        nickname: undefined,
        orderStatus: undefined,
        startDate: undefined,
        endDate: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      const idText = Array.isArray(ids) ? ids.join(', ') : String(ids)
      this.$confirm({
        title: this.$t('views.orderSettlement.confirm.deleteTitle'),
        content: this.$t('views.orderSettlement.confirm.deleteContent', { ids: idText }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delOrderSettlement(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.orderSettlement.msg.deleteOk'),
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.orderSettlement.confirm.exportTitle'),
        content: this.$t('views.orderSettlement.confirm.exportContent'),
        onOk () {
          const time = new Date().getTime()
          that.download('user/order-settlement/export', {
            ...that.queryParam
          }, that.$t('views.orderSettlement.export.filename', { time }))
        },
        onCancel () {}
      })
    }
  }
}
</script>
